import { DashboardView } from '../views/dashboard/dashboard.view';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DevPlaygroundComponent } from './components/dev.playground/dev.playground.component';

import { AuthGuardService } from 'app/services/auth.guard.service';


const PlaygroundRouting: Routes = [
    // login view
    {

        path: 'dev', component: DashboardView,
        canActivate: [AuthGuardService],
        children: [
            { path: 'playground', component: DevPlaygroundComponent },

            // handle all other routes
            { path: '**', component: DevPlaygroundComponent } // AccountDashboardComponent
        ]
    },
];


@NgModule({
    imports: [RouterModule.forChild(PlaygroundRouting)],
    exports: [RouterModule]
})
export class PlaygroundRoutingModule { }
